"use strict";

let core = require("../helpers/core");
let tracking = require("./tracking");
let sessionStore = require("./storage").session;
let pageId = document.getElementById("pageId").getAttribute("data-page-id");
let lastTabStoreKey = "lastTab" + pageId;
let tabIds = ["cars", "moto", "caravan", "trucks"];

let trackingTabMapping = {
  cars: "car",
  moto: "moto",
  caravan: "caravan",
  trucks: "truck"
};

function setTabActiveState(tab, tabId, desiredActiveTabId) {
  if (tab) {
    if (tabId === desiredActiveTabId) {
      core.show(tab);
      core.addClass(document.querySelector("button[data-tab-id='" + tabId + "']"), "sc-tab--with-icon--active");
    } else {
      core.hide(tab);
      core.removeClass(document.querySelector("button[data-tab-id='" + tabId + "']"), "sc-tab--with-icon--active");
    }
  }
}

function setTabAsActive(desiredActiveTabId) {
  tabIds.forEach(tabId => {
    setTabActiveState(document.getElementById("home-box-" + tabId + "-search"), tabId, desiredActiveTabId);
  });
}

function track(boxId) {
  tracking.clickEvent("home-searchbox-tabs", trackingTabMapping[boxId]);
}

function saveActiveTab(tabId) {
  sessionStore.set(lastTabStoreKey, tabId);
}

function restoreActiveTab() {
  let tabId = sessionStore.get(lastTabStoreKey);
  if (tabId) {
    setTabAsActive(tabId);
  }
}

var initTabs = function() {
  Array.prototype.forEach.call(document.querySelectorAll("[data-tab-nav]"), function(tab) {
    core.addEvent(tab, "click", function() {
      let tabId = tab.getAttribute("data-tab-id");
      setTabAsActive(tabId);
      saveActiveTab(tabId);
      track(tabId);
    });
  });
  restoreActiveTab();
};

module.exports = {
  init: initTabs
};
